export function elipsis(text, maxLength = 13) {
  if (!text || text.length <= maxLength) return text ?? '';
  const half = Math.floor((maxLength - 3) / 2);
  return text.slice(0, half) + '...' + text.slice(-half);
}
